<div id="option">
  <span id="icon" class="sdps-text-body option-text">
    <sdps-icon color="active" type="functional" name={{this.schwabIcon}} size="small">
    </sdps-icon>
  </span>
  <span class="sdps-text-body option-text" id="icon-text">{{this.text}}</span>
</div>
